import * as React from 'react';
import { motion } from 'framer-motion';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { handleHrefClick } from '../helpers.js';
import SubMenuLinks from './SubMenuLinks.js';

const subMenuContainer = {
    hidden: {
        x: '0%',
        // Instead of 1 SubMenu multiple can be rendered, make sure to hide the inactive ones
        display: 'none',
        transition: {
            ease: 'easeIn',
            duration: 0.3
        },
        transitionEnd: {
            display: 'none'
        }
    },
    visible: {
        x: '-100%',
        display: 'flex',
        transition: {
            duration: 0.3,
            ease: 'easeOut'
        }
    }
};
const SubMenu = ({ active , menuItems , hideSubMenu  })=>{
    const firstLink = React.useRef(null);
    // TODO: find a way to make this work for keyboard and screenreader users
    // without needing to focus() also in mouse or regular mobile usage.
    // Please do not remove without testing with both keyboard and screen reader mode (Cmd+F5)
    React.useEffect(()=>{
        if (active) {
            setTimeout(()=>{
                var ref;
                return (ref = firstLink.current) === null || ref === void 0 ? void 0 : ref.focus();
            }, 50);
        }
    }, [
        active
    ]);
    const keyUp = React.useCallback((e)=>{
        if (e.key === 'Escape') {
            hideSubMenu(true);
            e.stopPropagation();
        }
    }, [
        hideSubMenu
    ]);
    return /*#__PURE__*/ React.createElement(motion.div, {
        className: "site-nav-mobile__page",
        animate: active ? 'visible' : 'hidden',
        variants: subMenuContainer,
        "aria-hidden": !active
    }, /*#__PURE__*/ React.createElement("div", {
        className: "site-nav-mobile-submenu",
        onKeyUp: keyUp,
        role: "presentation"
    }, menuItems.map(({ childMenuItems , label , link , parameters  }, index)=>{
         return React.createElement("div", {
            className: "site-nav-mobile-submenu__column",
            key: label
        }, (link === null || link === void 0 ? void 0 : link.href) ? /*#__PURE__*/ React.createElement("a", {
            className: "site-nav-mobile-submenu__link--mobile",
            onClick: handleHrefClick,
            href: link.href,
            ref: index === 0 ? firstLink : null
        }, (parameters === null || parameters === void 0 ? void 0 : parameters.icon) ? /*#__PURE__*/ React.createElement("span", {
            className: "site-nav-mobile-submenu__icon"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: parameters.icon
        })) : null, label) : /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            className: "site-nav-mobile-submenu__title",
            component: "p"
        }, label), (childMenuItems === null || childMenuItems === void 0 ? void 0 : childMenuItems.length) ? /*#__PURE__*/ React.createElement(SubMenuLinks, {
            items: childMenuItems,
            ariaLabel: label
        }) : null);
    })));
};

export { SubMenu as default };
//# sourceMappingURL=SubMenu.js.map
